import { FrVrfSpreadsheet } from "@vrf/fr-vrf-spreadsheet-react";
import React, { useEffect, useMemo } from "react";
import {
  CpntCnvRuleSpreadsheetState,
  EnvCopyCpntAttrCnvRuleRow,
  EnvCopyIfDfnCnvRuleRow,
  EnvCopyReqSpreadsheetState,
  IfCnvRuleSpreadsheetState,
  displayColumnCpntCnvRules,
  displayColumnIfCnvRules,
  usePageState,
} from ".";
import { useAppState } from "../../app/useAppState";
import { Option } from "../../util/option";

import { isDisplayedAction } from "@vrf/fr-vrf-auth-core";
import {
  useGlobalNotifier,
  useMessage,
  useSpreadsheetState,
} from "@vrf/fr-vrf-core-react";
import {
  FrVrfAccordion,
  FrVrfButton,
  FrVrfButtonPanel,
  FrVrfDropdownField,
  FrVrfFooter,
  FrVrfFormPanel,
  FrVrfPanel,
  FrVrfSingleLineDisplayField,
} from "@vrf/fr-vrf-web-components-react";
import { ApplicationMessageScreen } from "../../messages/screen-message";
import {
  DeleteComponentConversionRulesRequest,
  EnvCopyComponentAttrCnvRule,
  UpdateComponentConversionRulesRequest,
  useDeleteComponentConversionRules,
  useGetComponentConversionRules,
  useUpdateComponentConversionRules,
} from "../../services/component-conversion-rules";
import {
  useGetComponentAttributeList,
  useGetDipByRegionList,
  useGetDipEnvironmentStateManagementList,
  useGetGeneralCodes,
  useGetIfItemList,
} from "../../services/data-list";
import {
  CreateEnvironmentCopyRequestRequest,
  useCreateEnvironmentCopyRequest,
  useUpdateEnvironmentCopyRequest,
} from "../../services/environment-copy-request";
import { useGetEnvironmentCopyRequests } from "../../services/environment-copy-requests";
import {
  EnvCopyIfDfnCnvRule,
  useDeleteIfConversionRules,
  useGetIfConversionRules,
  useUpdateIfConversionRules,
} from "../../services/if-conversion-rules";
import {
  DeleteIfConversionRulesRequest,
  UpdateIfConversionRulesRequest,
} from "../../services/if-conversion-rules/";
import { useGetRootComponents } from "../../services/root-components";
import { mappingErrorResponseToSpreadsheet } from "../../util";
import { ENV } from "@vrf/fr-vrf-core";
import {
  CpntAttrCnvRuleType,
  EnvCopyDeploymentRequestResultDivisionCode,
  EnvTypeCd,
  IfDfnCnvRuleType,
} from "../../util/general-code/enums/general-codes";
import { removeMilliseconds } from "../../util/date-util";
import _ from "lodash";
import { Cell } from "@vrf/fr-vrf-spreadsheet-core-templating";

const IF_DFN_CNV_RULE_CD = "if_dfn_cnv_rule_type";
const CPNT_ATTR_CNV_RULE_CD = "cpnt_attr_cnv_rule_type";

const CANCEL_BUTTON_AUTH_ACTION_ID = "environment_copy.button.cancel";

export const EnvironmentCopyPageContent = () => {
  const { showToast, showConfirmationDialog } = useGlobalNotifier();
  const { messageForScreen } = useMessage();

  const [_appState, setAppState] = useAppState();
  const [pageState, setPageState] = usePageState();

  const [getDipByRegionListResponse, sendGetDipByRegionList] =
    useGetDipByRegionList();

  const [getIfItemListResponse, sendGetIfItemList] = useGetIfItemList();

  const [
    getDipEnvironmentStateManagementListResponse,
    sendGetDipEnvironmentStateManagementList,
  ] = useGetDipEnvironmentStateManagementList();

  const [getComponentAttributeListReponse, sendGetComponentAttributeList] =
    useGetComponentAttributeList();

  const [getIfConversionRulesResponse, sendGetIfConversionRules] =
    useGetIfConversionRules();

  const [updateIfConversionRulesResponse, sendUpdateIfConversionRules] =
    useUpdateIfConversionRules();

  const [deleteIfConversionRulesResponse, sendDeleteIfConversionRules] =
    useDeleteIfConversionRules();

  const [getComponentConversionRulesResponse, sendGetComponentConversionRules] =
    useGetComponentConversionRules();

  const [
    updateComponentConversionRulesResponse,
    sendUpdateComponentConversionRules,
  ] = useUpdateComponentConversionRules();

  const [
    deleteComponentConversionRulesResponse,
    sendDeleteComponentConversionRules,
  ] = useDeleteComponentConversionRules();

  const [getRootComponentsResponse, sendGetRootComponents] =
    useGetRootComponents();

  const [getEnvironmentCopyRequestsResponse, sendGetEnvironmentCopyRequests] =
    useGetEnvironmentCopyRequests();
  const [
    updateEnvironmentCopyRequestResponse,
    sendUpdateEnvironmentCopyRequest,
  ] = useUpdateEnvironmentCopyRequest();
  const [
    createEnvironmentCopyRequestResponse,
    sendCreateEnvironmentCopyRequest,
  ] = useCreateEnvironmentCopyRequest();

  const [getGeneralCodesResponse, sendGetGeneralCodes] = useGetGeneralCodes();
  const { resetUserError } = useGlobalNotifier();

  const TEMPLATE_IF_FILE_URL =
    "spreadsheet-template//environment-copy-if-conversion-rule.xlsx";

  const TEMPLATE_CPNT_FILE_URL =
    "spreadsheet-template/environment-copy-component-conversion-rule.xlsx";

  const TEMPLATE_ENV_COPY_REQ_FILE_URL =
    "spreadsheet-template//environment-copy-requests.xlsx";

  const genCdToGenCdName = (cd: string, cdtype: string) => {
    const genCdList = getGeneralCodesResponse?.gnrlCdTypeList.filter(
      (cd) => cd.cdType === cdtype,
    )[0];
    return (
      genCdList?.cdList.filter((e) => e.label === cd).map((e) => e.label)[0] ??
      ""
    );
  };

  // >> UseEffect
  const onInitialDisplayed = () => {
    setAppState((prevState) => ({ ...prevState, title: "Environment Copy" }));
    sendGetDipByRegionList({});
    sendGetDipEnvironmentStateManagementList({});
    sendGetIfItemList({ dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM") });
    sendGetGeneralCodes({
      cdTypes: [IF_DFN_CNV_RULE_CD, CPNT_ATTR_CNV_RULE_CD],
    });
    resetUserError();
  };

  useEffect(onInitialDisplayed, []);

  const onGetGenGeneralCodesResponsed = () => {
    if (!getGeneralCodesResponse) {
      return;
    }
    setPageState((prevState) => ({
      ...prevState,
      generalCodes: [...getGeneralCodesResponse.gnrlCdTypeList],
    }));
  };
  useEffect(onGetGenGeneralCodesResponsed, [getGeneralCodesResponse]);

  const onGetIfItemListReponsed = () => {
    if (!getIfItemListResponse) return;
    setPageState((prevState) => ({
      ...prevState,
      ifItmList: [...getIfItemListResponse.ifItmGrpIfItmLkList],
    }));
  };
  useEffect(onGetIfItemListReponsed, [getIfItemListResponse]);

  const onGetDipByRegionListResponse = () => {
    if (!getDipByRegionListResponse) return;
    setPageState((prevState) => ({
      ...prevState,
      dipByRgnDropdown: getDipByRegionListResponse.dipByRgnList.map((e) => ({
        label: e.dipByRgn,
        value: e.dipByRgn,
      })),
    }));
  };
  useEffect(onGetDipByRegionListResponse, [getDipByRegionListResponse]);

  const onGetDipEnvironmentStateManagementList = () => {
    if (!getDipEnvironmentStateManagementListResponse) return;
    setPageState((prevState) => ({
      ...prevState,
      dipEnvrnmntSttMngList:
        getDipEnvironmentStateManagementListResponse.dipEnvrnmntSttMngList.map(
          (e) => ({ ...e }),
        ),
    }));
  };
  useEffect(onGetDipEnvironmentStateManagementList, [
    getDipEnvironmentStateManagementListResponse,
  ]);

  const onGetComponentAttributeListReponsed = () => {
    if (!getComponentAttributeListReponse) return;
    setPageState((prevState) => ({
      ...prevState,
      cpntAttrDropdown: getComponentAttributeListReponse.cpntAttrList.map(
        (e) => ({
          label: e.cpntAttrName,
          value: e.cpntAttrNum,
        }),
      ),
    }));
  };
  useEffect(onGetComponentAttributeListReponsed, [
    getComponentAttributeListReponse,
  ]);

  const onGetIfConversionRuleResponsed = () => {
    if (!getIfConversionRulesResponse) {
      return;
    }
    setPageState((prevState) => ({
      ...prevState,
      isSaved: true,
      searchResult: {
        ...prevState.searchResult,
        envCopyIfDfnCnvRules: [
          ...getIfConversionRulesResponse.envCopyIfDfnCnvRule,
        ],
      },
    }));
  };
  useEffect(onGetIfConversionRuleResponsed, [getIfConversionRulesResponse]);

  const onGetRootComponentsResponsed = () => {
    if (!getRootComponentsResponse) {
      return;
    }
    setPageState((prevState) => ({
      ...prevState,
      isSaved: true,
      cpntIdDropdown: getRootComponentsResponse.rootCpntList
        .filter(
          (e) => e.dipByRgn === prevState.searchConditions.dipByRgnSelected,
        )
        .flatMap((rootCpnt) =>
          rootCpnt.cpntList.map((cpnt) => ({
            label: cpnt.cpntId,
            value: cpnt.cpntId,
          })),
        ),
    }));
  };
  useEffect(onGetRootComponentsResponsed, [getRootComponentsResponse]);

  const onUpdateIfCnvSpreadSheet = () => {
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }

    if (!ifSpreadsheetState) return;

    if (Array.isArray(updateIfConversionRulesResponse)) {
      const newSpreadsheetRecordData = mappingErrorResponseToSpreadsheet(
        updateIfConversionRulesResponse,
        ifSpreadsheetState.envCopyIfDfnCnvRules,
        displayColumnIfCnvRules,
      );

      setIfSpreadsheetState({
        ...ifSpreadsheetState,
        envCopyIfDfnCnvRules: newSpreadsheetRecordData,
      });
      return;
    }
    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetIfConversionRules({
      envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
    });

    setPageState((prevState) => ({ ...prevState, isEdited: false }));
  };
  useEffect(onUpdateIfCnvSpreadSheet, [updateIfConversionRulesResponse]);

  const onDeleteIfCnvSpreadSheet = () => {
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }

    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetIfConversionRules({
      envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
      dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
    });

    setPageState((prevState) => ({ ...prevState, isEdited: false }));
  };
  useEffect(onDeleteIfCnvSpreadSheet, [deleteIfConversionRulesResponse]);

  const onGetComponentConversionRuleResponsed = () => {
    if (!getComponentConversionRulesResponse) {
      return;
    }
    setPageState((prevState) => ({
      ...prevState,
      isSaved: true,
      searchResult: {
        ...prevState.searchResult,
        envCopyCpntAttrCnvRules: [
          ...getComponentConversionRulesResponse.envCopyCpntAttrCnvRule,
        ],
      },
    }));
  };
  useEffect(onGetComponentConversionRuleResponsed, [
    getComponentConversionRulesResponse,
  ]);

  const onGetEnvironmentCopyRequestsResponsed = () => {
    if (!getEnvironmentCopyRequestsResponse) {
      return;
    }
    setPageState((prevState) => ({
      ...prevState,
      isSaved: true,
      isDplyInPrgrss:
        getEnvironmentCopyRequestsResponse.envrnmntCopyDplymntReqMng.some(
          (e) =>
            e.envrnmntCopyDplymntReqRsltTypeCd ===
              EnvCopyDeploymentRequestResultDivisionCode.DEPLOYING ||
            e.envrnmntCopyDplymntReqRsltTypeCd ===
              EnvCopyDeploymentRequestResultDivisionCode.DEPLOYMENT_PENDING,
        ),
      searchResult: {
        ...prevState.searchResult,
        environmentCopyRequests: [
          ...getEnvironmentCopyRequestsResponse.envrnmntCopyDplymntReqMng,
        ],
      },
    }));
  };
  useEffect(onGetEnvironmentCopyRequestsResponsed, [
    getEnvironmentCopyRequestsResponse,
  ]);

  const onUpdateCpntCnvSpreadSheet = () => {
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }

    if (!cpntSpreadsheetState) return;
    if (Array.isArray(updateComponentConversionRulesResponse)) {
      const newSpreadsheetRecordData = mappingErrorResponseToSpreadsheet(
        updateComponentConversionRulesResponse,
        cpntSpreadsheetState.envCopyCpntAttrCnvRules,
        displayColumnCpntCnvRules,
      );

      setCpntSpreadsheetState({
        ...cpntSpreadsheetState,
        envCopyCpntAttrCnvRules: newSpreadsheetRecordData,
      });
      return;
    }

    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetComponentConversionRules({
      envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
    });
  };
  useEffect(onUpdateCpntCnvSpreadSheet, [
    updateComponentConversionRulesResponse,
  ]);

  const onDeleteCpntCnvSpreadSheet = () => {
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }

    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetComponentConversionRules({
      envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
    });
  };
  useEffect(onDeleteCpntCnvSpreadSheet, [
    deleteComponentConversionRulesResponse,
  ]);

  const onUpdateEnvCopyReqResponsed = () => {
    if (!pageState.searchConditions.copyToSelected) {
      return;
    }

    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetEnvironmentCopyRequests({
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
    });
  };
  useEffect(onUpdateEnvCopyReqResponsed, [
    updateEnvironmentCopyRequestResponse,
  ]);

  const onCreateEnvCopyReqResponsed = () => {
    if (!pageState.searchConditions.copyToSelected) {
      return;
    }

    showToast({
      design: "completion",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00044),
    });
    sendGetEnvironmentCopyRequests({
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
    });
  };
  useEffect(onCreateEnvCopyReqResponsed, [
    createEnvironmentCopyRequestResponse,
  ]);
  //<< UseEffect

  //>> Spreadsheet IF Conversion Rule
  const [ifSpreadsheetState, setIfSpreadsheetState, initIfSpreadsheetState] =
    useSpreadsheetState<IfCnvRuleSpreadsheetState>();

  const spreadsheetIfInitialData = useMemo(() => {
    return {
      envCopyIfDfnCnvRules: pageState.searchResult.envCopyIfDfnCnvRules.map(
        (e) => ({
          envCopyIfDfnCnvRule: { ...e },
          addFlg: false,
          isEdited: false,
          delChecked: false,
          ifItmDropdown: pageState.ifItmList
            .filter((itm) => itm.ifItmGrpNum == e.ifItmGrpNum)
            .map((itm) => ({
              value: String(itm.ifItmNum),
              label: itm.ifItmLgclName,
            })),
        }),
      ),
      ifItmGrpList: Array.from(
        pageState.ifItmList
          .map((itm) => ({
            value: String(itm.ifItmGrpNum),
            label: itm.ifItmGrpLgclName,
          }))
          .reduce((map, obj) => map.set(obj.value, obj), new Map())
          .values(),
      ),
      isDplyInPrgrss: pageState.isDplyInPrgrss,
    };
  }, [pageState.searchResult, pageState.ifItmList]);

  const onEditIfSpreadsheet = (event: CustomEvent) => {
    const eventName: string = event.detail.name;
    if (!ifSpreadsheetState) return;

    setPageState((prevState) => ({ ...prevState, isEdited: true }));

    switch (eventName) {
      case "deleteCheckBox":
        setIfSpreadsheetState({
          ...ifSpreadsheetState,
          envCopyIfDfnCnvRules: ifSpreadsheetState.envCopyIfDfnCnvRules.map(
            (row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    delChecked: !row.delChecked,
                  }
                : row,
          ),
        });
        break;

      case "ifItmLgclName":
        setIfSpreadsheetState({
          ...ifSpreadsheetState,
          envCopyIfDfnCnvRules: ifSpreadsheetState.envCopyIfDfnCnvRules.map(
            (row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyIfDfnCnvRule: {
                      ...row.envCopyIfDfnCnvRule,
                      ifItmNum: event.detail.cell.value,
                      ifItmLgclName:
                        row.ifItmDropdown.find(
                          (itm) => itm.value == event.detail.cell.value,
                        )?.label ?? "",
                    },
                  }
                : row,
          ),
        });
        break;

      case "ifItmGrpLgclName":
        setIfSpreadsheetState({
          ...ifSpreadsheetState,
          envCopyIfDfnCnvRules: ifSpreadsheetState.envCopyIfDfnCnvRules.map(
            (row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    ifItmDropdown: pageState.ifItmList
                      .filter(
                        (itm) => itm.ifItmGrpNum == event.detail.cell.value,
                      )
                      .map((itm) => ({
                        value: String(itm.ifItmNum),
                        label: itm.ifItmLgclName,
                      })),

                    isEdited: true,
                    envCopyIfDfnCnvRule: {
                      ...row.envCopyIfDfnCnvRule,
                      ifItmNum: pageState.ifItmList
                        .filter(
                          (itm) => itm.ifItmGrpNum == event.detail.cell.value,
                        )
                        .map((itm) => itm.ifItmNum)[0],
                      ifItmLgclName: pageState.ifItmList
                        .filter(
                          (itm) => itm.ifItmGrpNum == event.detail.cell.value,
                        )
                        .map((itm) => itm.ifItmLgclName)[0],
                      ifItmGrpNum: event.detail.cell.value,
                      ifItmGrpLgclName:
                        ifSpreadsheetState.ifItmGrpList.find(
                          (itm) => itm.value == event.detail.cell.value,
                        )?.label ?? "",
                    },
                  }
                : row,
          ),
        });
        break;

      case "ifDfnCnvRuleTypeName":
        setIfSpreadsheetState({
          ...ifSpreadsheetState,
          envCopyIfDfnCnvRules: ifSpreadsheetState.envCopyIfDfnCnvRules.map(
            (row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyIfDfnCnvRule: {
                      ...row.envCopyIfDfnCnvRule,
                      ifDfnCnvRuleTypeCd: event.detail.cell.value,
                      ifDfnCnvRuleTypeName: genCdToGenCdName(
                        event.detail.cell.value,
                        IF_DFN_CNV_RULE_CD,
                      ),
                      rplcmntFromAttrStngVal:
                        event.detail.cell.value === IfDfnCnvRuleType.REPLACE
                          ? row.envCopyIfDfnCnvRule.rplcmntFromAttrStngVal
                          : "",
                      rplcmntToAttrStngVal:
                        event.detail.cell.value === IfDfnCnvRuleType.REPLACE
                          ? row.envCopyIfDfnCnvRule.rplcmntToAttrStngVal
                          : "",
                      prefxStngVal:
                        event.detail.cell.value === IfDfnCnvRuleType.PREFIX
                          ? row.envCopyIfDfnCnvRule.prefxStngVal
                          : "",
                    },
                  }
                : row,
          ),
        });
        break;

      default:
        setIfSpreadsheetState({
          ...ifSpreadsheetState,
          envCopyIfDfnCnvRules: ifSpreadsheetState.envCopyIfDfnCnvRules.map(
            (row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyIfDfnCnvRule: {
                      ...row.envCopyIfDfnCnvRule,
                      [eventName]: event.detail.cell.value,
                    },
                  }
                : row,
          ),
        });
        break;
    }
  };

  /**
   * Add Row Button Clicked.
   * @param event that is passed from spreadsheet.
   */
  const onIfAddRowClicked = () => {
    if (!ifSpreadsheetState) return;
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }
    const insertRowIndex: number =
      (pageState.ifSpreadsheetSelectedRowIndex ?? 0) + 1;

    const newSpreadsheetState = ifSpreadsheetState
      ? [...ifSpreadsheetState.envCopyIfDfnCnvRules]
      : [];
    const addSpreadsheetRow: EnvCopyIfDfnCnvRuleRow = {
      errorColumnList: [],
      errorMessage: "",
      messageList: [],
      addFlg: true,
      isEdited: true,
      delChecked: false,
      ifItmDropdown: pageState.ifItmList
        .filter((itm) => itm.ifItmGrpNum == pageState.ifItmList[0].ifItmGrpNum)
        .map((itm) => ({
          value: String(itm.ifItmNum),
          label: itm.ifItmLgclName,
        })),
      envCopyIfDfnCnvRule: {
        ifDfnCnvRuleId: "",
        envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
        envrnmntIdTo: pageState.searchConditions.copyToSelected,
        cpntId: "",
        bdryId: "",
        ifItmGrpNum: pageState.ifItmList[0].ifItmGrpNum,
        ifItmGrpLgclName: pageState.ifItmList[0].ifItmGrpLgclName,
        ifItmNum: pageState.ifItmList[0].ifItmNum,
        ifItmLgclName: pageState.ifItmList[0].ifItmLgclName,
        ifDfnCnvRuleTypeCd: IfDfnCnvRuleType.REPLACE,
        ifDfnCnvRuleTypeName: "Replace",
        rplcmntFromAttrStngVal: "",
        rplcmntToAttrStngVal: "",
        prefxStngVal: "",
        updateDateTime: "",
      },
    };
    newSpreadsheetState.splice(insertRowIndex, 0, addSpreadsheetRow);
    setIfSpreadsheetState({
      ...ifSpreadsheetState,
      envCopyIfDfnCnvRules: [...newSpreadsheetState],
    });
  };

  /**
   * Spreadsheet cell selected.
   * @param event that is passed from spreadsheet.
   */
  const onIfCellSelected = (event: CustomEvent) => {
    const rowIndex: number = event.detail.cell?.data.index;
    setPageState((prevState) => ({
      ...prevState,
      ifSpreadsheetSelectedRowIndex: rowIndex,
    }));
  };

  /**
   * @param event that is passed from spreadsheet.
   */
  const onIfSaveButtonClicked = (event: CustomEvent) => {
    if (!ifSpreadsheetState) return;

    const req: UpdateIfConversionRulesRequest = {
      envCopyIfDfnCnvRule: ifSpreadsheetState.envCopyIfDfnCnvRules
        .map((row, idx) => ({
          idx: idx,
          isEdited: row.isEdited,
          ...row.envCopyIfDfnCnvRule,
          bdryId: row.envCopyIfDfnCnvRule.bdryId ?? "",
          rplcmntFromAttrStngVal:
            row.envCopyIfDfnCnvRule.rplcmntFromAttrStngVal ?? "",
          rplcmntToAttrStngVal:
            row.envCopyIfDfnCnvRule.rplcmntToAttrStngVal ?? "",
          prefxStngVal: row.envCopyIfDfnCnvRule.prefxStngVal ?? "",
        }))
        .filter((row) => row.isEdited),
    };

    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
      onOkButtonClicked: () => {
        resetUserError();
        sendUpdateIfConversionRules(req);
      },
    });
  };

  const onIfDeleteButtonClicked = (event: CustomEvent) => {
    if (!ifSpreadsheetState) return;

    const req: DeleteIfConversionRulesRequest = {
      envCopyIfDfnCnvRule: ifSpreadsheetState.envCopyIfDfnCnvRules
        .filter((row) => row.delChecked)
        .map((row, idx) => ({
          idx: idx,
          ...row.envCopyIfDfnCnvRule,
        })),
    };
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00170),
      onOkButtonClicked: () => {
        resetUserError();
        sendDeleteIfConversionRules(req);
      },
    });
  };

  /**
   * Spreadsheet delete icon clicked.
   * @param event that is passed from spreadsheet.
   */
  const onIfDeleteIconClicked = (event: CustomEvent) => {
    if (!ifSpreadsheetState) return;
    if (event.detail.name !== "deleteIcon") return;

    const newSpreadsheetRow: EnvCopyIfDfnCnvRuleRow[] = [
      ...ifSpreadsheetState.envCopyIfDfnCnvRules,
    ];
    const rowIndex: number = event.detail.cell?.data.index;
    newSpreadsheetRow.splice(rowIndex, 1);

    setIfSpreadsheetState({
      ...ifSpreadsheetState,
      envCopyIfDfnCnvRules: newSpreadsheetRow,
    });
  };

  //<< Spreadsheet IF Conversion Rule

  //>> Spreadsheet Component Conversion Rule
  const [
    cpntSpreadsheetState,
    setCpntSpreadsheetState,
    initCpntSpreadsheetState,
  ] = useSpreadsheetState<CpntCnvRuleSpreadsheetState>();

  const spreadsheetCpntInitialData = useMemo(() => {
    return {
      cpntAttrDropdown: pageState.cpntAttrDropdown.map((e) => ({
        label: e.label,
        value: String(e.value),
      })),
      cpntIdDropdown: [{ label: "", value: "" }, ...pageState.cpntIdDropdown],
      envCopyCpntAttrCnvRules:
        pageState.searchResult.envCopyCpntAttrCnvRules.map((e) => ({
          envCopyCpntAttrCnvRule: { ...e },
          addFlg: false,
          isEdited: false,
          delChecked: false,
        })),
      isDplyInPrgrss: pageState.isDplyInPrgrss,
    };
  }, [
    pageState.searchResult,
    pageState.cpntAttrDropdown,
    pageState.cpntIdDropdown,
  ]);

  const onEditCpntSpreadsheet = (event: CustomEvent) => {
    const eventName: string = event.detail.name;
    if (!cpntSpreadsheetState) return;

    setPageState((prevState) => ({ ...prevState, isEdited: true }));

    switch (eventName) {
      case "deleteCheckBox":
        setCpntSpreadsheetState({
          ...cpntSpreadsheetState,
          envCopyCpntAttrCnvRules:
            cpntSpreadsheetState.envCopyCpntAttrCnvRules.map((row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    delChecked: !row.delChecked,
                  }
                : row,
            ),
        });
        break;

      case "cpntAttrName":
        setCpntSpreadsheetState({
          ...cpntSpreadsheetState,
          envCopyCpntAttrCnvRules:
            cpntSpreadsheetState.envCopyCpntAttrCnvRules.map((row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyCpntAttrCnvRule: {
                      ...row.envCopyCpntAttrCnvRule,
                      cpntAttrNum: event.detail.cell.value,
                      cpntAttrName:
                        cpntSpreadsheetState.cpntAttrDropdown.find(
                          (itm) => itm.value === event.detail.cell.value,
                        )?.label ?? "",
                    },
                  }
                : row,
            ),
        });
        break;

      case "cpntAttrCnvRuleTypeName":
        setCpntSpreadsheetState({
          ...cpntSpreadsheetState,
          envCopyCpntAttrCnvRules:
            cpntSpreadsheetState.envCopyCpntAttrCnvRules.map((row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyCpntAttrCnvRule: {
                      ...row.envCopyCpntAttrCnvRule,
                      cpntAttrCnvRuleTypeCd: event.detail.cell.value,
                      cpntAttrCnvRuleTypeName: genCdToGenCdName(
                        event.detail.cell.value,
                        CPNT_ATTR_CNV_RULE_CD,
                      ),
                      rplcmntFromAttrStngVal:
                        event.detail.cell.value === CpntAttrCnvRuleType.REPLACE
                          ? row.envCopyCpntAttrCnvRule.rplcmntFromAttrStngVal
                          : "",
                      rplcmntToAttrStngVal:
                        event.detail.cell.value === CpntAttrCnvRuleType.REPLACE
                          ? row.envCopyCpntAttrCnvRule.rplcmntToAttrStngVal
                          : "",
                      attrStngVal:
                        event.detail.cell.value === CpntAttrCnvRuleType.FIX
                          ? row.envCopyCpntAttrCnvRule.attrStngVal
                          : "",
                    },
                  }
                : row,
            ),
        });
        break;

      default:
        setCpntSpreadsheetState({
          ...cpntSpreadsheetState,
          envCopyCpntAttrCnvRules:
            cpntSpreadsheetState.envCopyCpntAttrCnvRules.map((row, idx) =>
              idx === event.detail.cell.data.index
                ? {
                    ...row,
                    isEdited: true,
                    envCopyCpntAttrCnvRule: {
                      ...row.envCopyCpntAttrCnvRule,
                      [eventName]: event.detail.cell.value,
                    },
                  }
                : row,
            ),
        });
        break;
    }
  };

  const onBulkEditIfSpreadsheet = (event: CustomEvent) => {
    if (!ifSpreadsheetState) return;
    const newEnvCopyIfAttrCnvRules = _.cloneDeep(
      ifSpreadsheetState?.envCopyIfDfnCnvRules,
    ) as EnvCopyIfDfnCnvRuleRow[];

    const colName = event.detail.name as
      | keyof EnvCopyIfDfnCnvRule
      | "delChecked";

    event.detail.affectedCells.cells.forEach((item: Cell) => {
      const value: string = item.value;
      const rowIdx: number = item.data.index;

      if (colName === "delChecked") {
        newEnvCopyIfAttrCnvRules[rowIdx].delChecked = value === "true";
      } else {
        newEnvCopyIfAttrCnvRules[rowIdx].envCopyIfDfnCnvRule[colName] =
          value as never;
      }
    });

    setIfSpreadsheetState({
      ...ifSpreadsheetState,
      envCopyIfDfnCnvRules: newEnvCopyIfAttrCnvRules,
    });
  };

  const onBulkEditCpntSpreadsheet = (event: CustomEvent) => {
    if (!cpntSpreadsheetState) return;
    const newEnvCopyCpntAttrCnvRules = _.cloneDeep(
      cpntSpreadsheetState?.envCopyCpntAttrCnvRules,
    ) as EnvCopyCpntAttrCnvRuleRow[];
    const colName = event.detail.name as
      | keyof EnvCopyComponentAttrCnvRule
      | "delChecked";

    event.detail.affectedCells.cells.forEach((item: Cell) => {
      const value: string = item.value;
      const rowIdx: number = item.data.index;

      if (colName === "delChecked") {
        newEnvCopyCpntAttrCnvRules[rowIdx].delChecked = value === "true";
      } else {
        newEnvCopyCpntAttrCnvRules[rowIdx].envCopyCpntAttrCnvRule[colName] =
          value;
      }
    });

    setCpntSpreadsheetState({
      ...cpntSpreadsheetState,
      envCopyCpntAttrCnvRules: newEnvCopyCpntAttrCnvRules,
    });
  };

  const onCpntSaveButtonClicked = (event: CustomEvent) => {
    if (!cpntSpreadsheetState) return;

    const req: UpdateComponentConversionRulesRequest = {
      envCopyCpntAttrCnvRules: cpntSpreadsheetState.envCopyCpntAttrCnvRules
        .map((row, idx) => ({
          isEdited: row.isEdited,
          idx: idx,
          ...row.envCopyCpntAttrCnvRule,
          cpntId: row.envCopyCpntAttrCnvRule.cpntId ?? "",
          rplcmntFromAttrStngVal:
            row.envCopyCpntAttrCnvRule.rplcmntFromAttrStngVal ?? "",
          rplcmntToAttrStngVal:
            row.envCopyCpntAttrCnvRule.rplcmntToAttrStngVal ?? "",
          attrStngVal: row.envCopyCpntAttrCnvRule.attrStngVal ?? "",
        }))
        .filter((row) => row.isEdited),
    };

    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
      onOkButtonClicked: () => {
        resetUserError();
        sendUpdateComponentConversionRules(req);
      },
    });
  };

  const onCpntDeleteButtonClicked = (event: CustomEvent) => {
    if (!cpntSpreadsheetState) return;

    const req: DeleteComponentConversionRulesRequest = {
      envCopyCpntAttrCnvRule: cpntSpreadsheetState.envCopyCpntAttrCnvRules
        .filter((row) => row.delChecked)
        .map((row, idx) => ({
          idx: idx,
          ...row.envCopyCpntAttrCnvRule,
        })),
    };
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00170),
      onOkButtonClicked: () => {
        resetUserError();
        sendDeleteComponentConversionRules(req);
      },
    });
  };

  const onCpntCellSelected = (event: CustomEvent) => {
    const rowIndex: number = event.detail.cell?.data.index;
    setPageState((prevState) => ({
      ...prevState,
      cpntSpreadsheetSelectedRowIndex: rowIndex,
    }));
  };

  const onCpntDeleteIconClicked = (event: CustomEvent) => {
    if (!cpntSpreadsheetState) return;
    if (event.detail.name !== "deleteIcon") return;

    const newSpreadsheetRow: EnvCopyCpntAttrCnvRuleRow[] = [
      ...cpntSpreadsheetState.envCopyCpntAttrCnvRules,
    ];
    const rowIndex: number = event.detail.cell?.data.index;
    newSpreadsheetRow.splice(rowIndex, 1);

    setCpntSpreadsheetState({
      ...cpntSpreadsheetState,
      envCopyCpntAttrCnvRules: newSpreadsheetRow,
    });
  };

  /**
   * Add Row Button Clicked.
   * @param event that is passed from spreadsheet.
   */
  const onCpntAddRowClicked = () => {
    if (!cpntSpreadsheetState) return;
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }
    const insertRowIndex: number =
      (pageState.cpntSpreadsheetSelectedRowIndex ?? 0) + 1;

    const newSpreadsheetState = ifSpreadsheetState
      ? [...cpntSpreadsheetState.envCopyCpntAttrCnvRules]
      : [];
    const addSpreadsheetRow: EnvCopyCpntAttrCnvRuleRow = {
      errorColumnList: [],
      errorMessage: "",
      messageList: [],
      addFlg: true,
      isEdited: true,
      delChecked: false,
      envCopyCpntAttrCnvRule: {
        cpntAttrCnvRuleId: "",
        envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
        envrnmntIdTo: pageState.searchConditions.copyToSelected,
        cpntAttrNum: pageState.cpntAttrDropdown[0].value,
        cpntAttrName: pageState.cpntAttrDropdown[0].label,
        cpntId: "",
        cpntAttrCnvRuleTypeCd: CpntAttrCnvRuleType.REPLACE,
        cpntAttrCnvRuleTypeName: "Replace",
        rplcmntFromAttrStngVal: "",
        rplcmntToAttrStngVal: "",
        attrStngVal: "",
        updateDateTime: "",
      },
    };
    newSpreadsheetState.splice(insertRowIndex, 0, addSpreadsheetRow);
    setCpntSpreadsheetState({
      ...cpntSpreadsheetState,
      envCopyCpntAttrCnvRules: [...newSpreadsheetState],
    });
  };

  //<< Spreadsheet Component Conversion Rule

  //>> Spreadsheet Environment Copy Request
  const [
    envCopyReqSpreadsheetState,
    setEnvCopyReqSpreadsheetState,
    initEnvCopyReqSpreadsheetState,
  ] = useSpreadsheetState<EnvCopyReqSpreadsheetState>();

  const envCopyReqSpreadsheetInitialData = useMemo(() => {
    return {
      environmentCopyRequests:
        pageState.searchResult.environmentCopyRequests.map((e) => ({
          environmentCopyRequest: { ...e },
          cancel:
            e.envrnmntCopyDplymntReqRsltTypeCd ===
              EnvCopyDeploymentRequestResultDivisionCode.DEPLOYMENT_PENDING &&
            isDisplayedAction(CANCEL_BUTTON_AUTH_ACTION_ID)
              ? "Cancel"
              : undefined,
        })),
      removeMilliseconds,
    };
  }, [pageState.searchResult]);

  const onEnvCopyCancelClicked = (event: CustomEvent) => {
    if (!envCopyReqSpreadsheetState) return;

    if (
      event.detail.name !== "cancel" ||
      !isDisplayedAction(CANCEL_BUTTON_AUTH_ACTION_ID)
    ) {
      return;
    }

    const toCancelRow = envCopyReqSpreadsheetState.environmentCopyRequests.find(
      (row, idx) => idx === event.detail.cell.data.index,
    );
    if (
      !toCancelRow ||
      toCancelRow.environmentCopyRequest.envrnmntCopyDplymntReqRsltTypeCd !==
        EnvCopyDeploymentRequestResultDivisionCode.DEPLOYMENT_PENDING
    ) {
      return;
    }

    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: messageForScreen(ApplicationMessageScreen.APP_SCN_00171),
      onOkButtonClicked: () => {
        resetUserError();
        sendUpdateEnvironmentCopyRequest({
          envrnmntCopyDplymntReqSeqNum:
            toCancelRow.environmentCopyRequest.envrnmntCopyDplymntReqSeqNum,
          updateDateTime: toCancelRow.environmentCopyRequest.updateDateTime,
        });
      },
    });
  };
  //<< Spreadsheet Environment Copy Request

  const onCopyButtonClicked = () => {
    if (
      !pageState.searchConditions.copyFromSelected ||
      !pageState.searchConditions.copyToSelected
    ) {
      return;
    }
    const req: CreateEnvironmentCopyRequestRequest = {
      envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
      envrnmntIdTo: pageState.searchConditions.copyToSelected,
    };
    showConfirmationDialog({
      type: "confirm",
      title: "",
      message: pageState.isEdited
        ? [
            messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
            messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
          ]
        : messageForScreen(ApplicationMessageScreen.APP_SCN_00045),
      onOkButtonClicked: () => {
        resetUserError();
        sendCreateEnvironmentCopyRequest(req);
      },
    });
  };

  const valueChangedHandleDip = (event: CustomEvent) => {
    setPageState((prevState) => ({
      ...prevState,
      searchConditions: {
        ...prevState.searchConditions,
        dipByRgnSelected: event.detail.value,
        copyFromSelected: prevState.dipEnvrnmntSttMngList.find(
          (e) =>
            e.envTypeCd === EnvTypeCd.STG && e.dipByRgn === event.detail.value,
        )?.envrnmntId,
      },
    }));
  };

  const valueChangedHandleCopyTo = (event: CustomEvent) => {
    setPageState((prevState) => ({
      ...prevState,
      searchConditions: {
        ...prevState.searchConditions,
        copyToSelected: event.detail.value,
      },
    }));
  };

  const copyToDropDown: () => Option[] = () => {
    return pageState.dipEnvrnmntSttMngList
      .filter(
        (e) =>
          e.envTypeCd === EnvTypeCd.OTHER_STG &&
          e.dipByRgn === pageState.searchConditions.dipByRgnSelected,
      )
      .map((e) => ({ label: e.envrnmntId, value: e.envrnmntId }));
  };

  const onClickSearch = () => {
    const search = () => {
      if (
        !pageState.searchConditions.copyFromSelected ||
        !pageState.searchConditions.copyToSelected ||
        !pageState.searchConditions.dipByRgnSelected
      ) {
        return;
      }
      sendGetIfConversionRules({
        envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
        envrnmntIdTo: pageState.searchConditions.copyToSelected,
        dfnSetVerNum: ENV("REACT_APP_DFN_SET_VER_NUM"),
      });

      sendGetComponentConversionRules({
        envrnmntIdFrom: pageState.searchConditions.copyFromSelected,
        envrnmntIdTo: pageState.searchConditions.copyToSelected,
      });

      sendGetComponentAttributeList({
        dipByRgn: pageState.searchConditions.dipByRgnSelected,
      });

      sendGetRootComponents({});

      sendGetEnvironmentCopyRequests({
        envrnmntIdTo: pageState.searchConditions.copyToSelected,
      });
    };

    if (pageState.isEdited) {
      showConfirmationDialog({
        type: "confirm",
        title: "",
        message: messageForScreen(ApplicationMessageScreen.APP_SCN_00033),
        onOkButtonClicked: () => {
          resetUserError();
          setPageState((prevState) => ({ ...prevState, isEdited: false }));
          search();
        },
      });
      return;
    }
    resetUserError();
    search();
  };

  return (
    <>
      <FrVrfAccordion>
        <FrVrfPanel>
          <FrVrfFormPanel columns={2}>
            <FrVrfDropdownField
              labelContent="DIP by Region"
              onValueChanged={valueChangedHandleDip}
              items={pageState.dipByRgnDropdown}
              autocomplete={false}
              selectedValue={pageState.searchConditions?.dipByRgnSelected}
            />

            <FrVrfSingleLineDisplayField
              style={{
                "--vrf-single-line-display-field-font-size": "13px",
                "--vrf-single-line-display-field-label-font-size": "10px",
                "--vrf-single-line-display-field-label-width": "60px",
              }}
              label="Copy From"
              firstValue={pageState.searchConditions?.copyFromSelected}
            />

            <FrVrfDropdownField
              labelContent="Copy To"
              onValueChanged={valueChangedHandleCopyTo}
              items={copyToDropDown()}
              autocomplete={false}
              selectedValue={pageState.searchConditions?.copyToSelected}
            />
            <div style={{ textAlign: "center" }}></div>
          </FrVrfFormPanel>
          <FrVrfButtonPanel>
            <FrVrfButton
              content="Search"
              theme="primary"
              size="large"
              onClick={onClickSearch}
            />
          </FrVrfButtonPanel>
        </FrVrfPanel>
      </FrVrfAccordion>
      <FrVrfAccordion summary="IF Definitions Conversion Rule List">
        <FrVrfPanel>
          <FrVrfButtonPanel>
            <FrVrfButton
              content="Add Row"
              size="medium"
              theme="secondary"
              slot="left"
              onClicked={onIfAddRowClicked}
              disabled={pageState.isDplyInPrgrss}
              authActId="environment_copy.button.if_cnv_rule_add_row"
            />
          </FrVrfButtonPanel>
          <br />
          <FrVrfSpreadsheet
            data={spreadsheetIfInitialData}
            templateUrl={TEMPLATE_IF_FILE_URL}
            onInitialized={initIfSpreadsheetState}
            onCellSelected={onIfCellSelected}
            onCellClicked={onIfDeleteIconClicked}
            onCellEdited={onEditIfSpreadsheet}
            onCellBulkEdited={onBulkEditIfSpreadsheet}
            maxHeight={600}
          />
          <br />
          <FrVrfButtonPanel>
            <FrVrfButton
              content="Save"
              size="medium"
              theme="primary"
              onClicked={onIfSaveButtonClicked}
              disabled={
                !ifSpreadsheetState?.envCopyIfDfnCnvRules.some(
                  (e) => e.isEdited,
                )
              }
              authActId="environment_copy.button.if_cnv_rule_save"
            />
            <FrVrfButton
              content="Delete"
              size="medium"
              theme="primary"
              disabled={
                !ifSpreadsheetState?.envCopyIfDfnCnvRules.some(
                  (e) => e.delChecked,
                )
              }
              onClicked={onIfDeleteButtonClicked}
              authActId="environment_copy.button.if_cnv_rule_delete"
            />
          </FrVrfButtonPanel>
        </FrVrfPanel>
      </FrVrfAccordion>

      <FrVrfAccordion summary="Component Attribute Conversion Rule List">
        <FrVrfPanel>
          <FrVrfButtonPanel>
            <FrVrfButton
              content="Add Row"
              size="medium"
              theme="secondary"
              slot="left"
              disabled={pageState.isDplyInPrgrss}
              onClicked={onCpntAddRowClicked}
              authActId="environment_copy.button.cpnt_cnv_rule_add_row"
            />
          </FrVrfButtonPanel>
          <br />
          <FrVrfSpreadsheet
            data={spreadsheetCpntInitialData}
            templateUrl={TEMPLATE_CPNT_FILE_URL}
            onInitialized={initCpntSpreadsheetState}
            onCellSelected={onCpntCellSelected}
            onCellClicked={onCpntDeleteIconClicked}
            onCellEdited={onEditCpntSpreadsheet}
            onCellBulkEdited={onBulkEditCpntSpreadsheet}
            maxHeight={600}
          />
          <br />
          <FrVrfButtonPanel>
            <FrVrfButton
              content="Save"
              size="medium"
              theme="primary"
              disabled={
                !cpntSpreadsheetState?.envCopyCpntAttrCnvRules.some(
                  (e) => e.isEdited,
                )
              }
              onClicked={onCpntSaveButtonClicked}
              authActId="environment_copy.button.cpnt_cnv_rule_save"
            />
            <FrVrfButton
              content="Delete"
              size="medium"
              theme="primary"
              disabled={
                !cpntSpreadsheetState?.envCopyCpntAttrCnvRules.some(
                  (e) => e.delChecked,
                )
              }
              onClicked={onCpntDeleteButtonClicked}
              authActId="environment_copy.button.cpnt_cnv_rule_delete"
            />
          </FrVrfButtonPanel>
        </FrVrfPanel>
      </FrVrfAccordion>
      <FrVrfAccordion summary="Copy History">
        <FrVrfPanel>
          <FrVrfSpreadsheet
            data={envCopyReqSpreadsheetInitialData}
            templateUrl={TEMPLATE_ENV_COPY_REQ_FILE_URL}
            onInitialized={initEnvCopyReqSpreadsheetState}
            onCellClicked={onEnvCopyCancelClicked}
            maxHeight={600}
          />
        </FrVrfPanel>
      </FrVrfAccordion>
      <FrVrfFooter>
        <FrVrfButton
          content="Copy"
          theme="primary"
          size="large"
          disabled={pageState.isDplyInPrgrss}
          onClicked={onCopyButtonClicked}
          authActId="environment_copy.button.copy"
        />
      </FrVrfFooter>
    </>
  );
};
